import apiClient from "../../../network/apiClient";

/// Admin Management
// Add ADMIN
export const createUserAPI = (body) => apiClient.post("/user/create", body) 
export const updateUserAPI = (body) => apiClient.put("/user/update", body) 
export const fetchAllAdminAPI = () => apiClient.get("/user/getAllAdmins", { handle404Silently: true })
export const deleteUserByIdAPI = (id) => apiClient.delete(`/user/delete/${id}`)